module.exports = __webpack_public_path__ + "static/Deloitte-20e02bc46a21fb644db6903e18aa1eeb.png";